import { BarChartSquare02 } from "@untitled-ui/icons-react";
import { type TFunction } from "i18next";

export default {
  name: "report",
  priority: 10,
  icon: BarChartSquare02,
  menu: ({ t }: { t: TFunction }) => ({
    user: [],
    admin: [
      {
        label: t("Reports", { ns: "report.shared" }),
        icon: <BarChartSquare02 />,
        child: [
          {
            label: t("Report Management", { ns: "report.shared" }),
            to: "/admin/report/reports/",
            permission: "report.report.view",
          },
        ],
      },
    ],
  }),
} satisfies ModuleData;
